<template>
	<div class="header-bar">
		<div class="nav-bar">
			<div class="container">
				<b-navbar toggleable="lg" type="dark" class="nav-bar-content">
					<b-navbar-brand class="logo" @click="menu(1)"
						><img src="../assets/logo.png" height="60px"
					/></b-navbar-brand>
					<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
					<b-collapse id="nav-collapse" is-nav>
						<b-navbar-nav class="ml-auto">
							<b-nav-item
								href="#"
								class="nav-font"
								:class="{ 'nav-on': num === 1 }"
								@click="menu(1)"
								>首页</b-nav-item
							>
							<b-nav-item-dropdown
								text="关于我们"
								toggle-class="nav-link-custom"
								right
								class="nav-font"
								:class="{ 'nav-on': num === 2 }"
							>
								<b-dropdown-item @click="menu(2, 19)">企业介绍</b-dropdown-item>
								<b-dropdown-item @click="menu(2, 20)">企业资质</b-dropdown-item>
								<b-dropdown-item @click="menu(2, 22)">战略理念</b-dropdown-item>
								<b-dropdown-item @click="menu(2, 23)">企业团建</b-dropdown-item>
							</b-nav-item-dropdown>
							<b-nav-item-dropdown
								text="业务类型"
								toggle-class="nav-link-custom"
								right
								class="nav-font"
								:class="{ 'nav-on': num === 3 }"
							>
								<b-dropdown-item @click="menu(3, 24)"
									>管道疏通业务</b-dropdown-item
								>
								<b-dropdown-item @click="menu(3, 25)"
									>城乡人口污染物无害化综合治理及再生资源循环利用</b-dropdown-item
								>
								<b-dropdown-item @click="menu(3, 26)"
									>社区经济业务</b-dropdown-item
								>
								<b-dropdown-item @click="menu(3, 27)"
									>大数据应用开发运营业务</b-dropdown-item
								>
							</b-nav-item-dropdown>
							<b-nav-item-dropdown
								text="新闻资讯"
								toggle-class="nav-link-custom"
								right
								class="nav-font"
								:class="{ 'nav-on': num === 4 }"
							>
								<b-dropdown-item @click="menu(4, 8, '公司新闻')"
									>公司新闻</b-dropdown-item
								>
								<b-dropdown-item @click="menu(4, 9, '媒体报道')"
									>媒体报道</b-dropdown-item
								>
								<b-dropdown-item @click="menu(4, 10, '通知公示')"
									>通知公示</b-dropdown-item
								>
							</b-nav-item-dropdown>
							<!-- <b-nav-item-dropdown
								text="产品中心"
								toggle-class="nav-link-custom"
								right
								class="nav-font"
							>
								<b-dropdown-item @click="menu(4)">杰恩凯</b-dropdown-item>
								<b-dropdown-item>蜂巢</b-dropdown-item>
							</b-nav-item-dropdown> -->
							<b-nav-item
								href="#"
								class="nav-font"
								:class="{ 'nav-on': num === 6 }"
								@click="menu(6)"
								>联系我们</b-nav-item
							>
						</b-navbar-nav>
					</b-collapse>
				</b-navbar>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HeaderBar',
	components: {},
	data() {
		return {
			num: 0,
		};
	},
	created() {},
	mounted() {
		if (this.$parent.$options.name === 'index') {
			this.num = 1;
		} else if (this.$parent.$options.name === 'about') {
			this.num = 2;
		} else if (this.$parent.$options.name === 'business') {
			this.num = 3;
		} else if (this.$parent.$options.name === 'newlist') {
			this.num = 4;
		} else if (this.$parent.$options.name === 'contact') {
			this.num = 6;
		}
	},
	methods: {
		menu(val, id, name) {
			if (val === 1) {
				this.$router.push({ path: '/' });
			} else if (val === 2) {
				this.$router.push({ path: 'about-us', query: { id: id } });
			} else if (val === 3) {
				this.$router.push({ path: 'business', query: { id: id } });
			} else if (val === 4) {
				this.$router.push({
					path: 'new-list',
					query: { category_id: id, categoryName: name },
				});
			} else if (val === 6) {
				this.$router.push({ path: 'contact' });
			}
		},
	},
};
</script>
<style lang="scss">
.header-bar {
	.nav-bar {
		width: 100%;
		background: #fff;
		border-bottom: 1px solid #eee;
		.nav-font {
			> a {
				color: #000;
				margin-right: 4rem;
				&:hover {
					border-bottom: 3px solid #007bff !important;
				}
			}
		}
		.nav-on {
			> a {
				border-bottom: 3px solid #007bff;
			}
		}
		.nav-font:nth-last-child(1) a {
			margin-right: 0;
		}
		.nav-bar-content {
			animation: fadeInUp 0.8s ease;
		}
	}
}
@media (max-width: 991px) {
	.header-bar {
		.topbar {
			.container {
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
			&-left {
				width: 100%;
				padding-bottom: 10px;
				margin-bottom: 10px;
				border-bottom: 1px dashed rgba(225, 227, 226, 0.2);
				text-align: center;
			}
			&-link {
				padding-left: 0;
				margin-left: 0;
				border: none;
			}
		}
	}
}
</style>
<style>
.dropdown-menu {
	border: none !important;
	box-shadow: 1px 1px 3px #999;
}
.dropdown-item:active {
	background-color: #007bff !important;
}
.navbar-dark .navbar-nav .nav-link {
	color: #000 !important;
	margin-right: 4rem;
	padding: 0.3rem 0 !important;
}
</style>
